import { CARD_TYPE } from "../../types/card-type";
import { Category } from "../../types/category";

export const GIFT_CARD_TYPE_OPTIONS: Category[] = [
    {
        id: "",
        name: "Ver todas",
    },
    {
        id: CARD_TYPE.MOVIECARD,
        name: "Moviecard",
    },
    {
        id: CARD_TYPE.CINEFAN,
        name: "Cinefan",
    },
    {
        id: CARD_TYPE.TICKETCARD,
        name: "Ticketcard",
    },
];
